import { Link } from "@inertiajs/react"

export function Footer() {
  return (
    <footer className="mt-auto w-full border-t-2 border-[hsl(var(--ch-primary))] bg-[hsl(var(--ch-surface))]">
      <div className="ch-container flex flex-col gap-8 py-12 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm space-y-4">
          <span className="ch-headline-md block uppercase text-[hsl(var(--ch-primary))]">CITY HALLER</span>
          <p className="text-sm leading-relaxed text-[hsl(var(--ch-muted))]">
            © 2026 City Haller Archive & Reporting Service. An independent municipal record.
          </p>
        </div>
        <nav className="flex flex-col gap-8 sm:flex-row sm:gap-16">
          <div className="space-y-3">
            <span className="ch-label-caps block border-b border-[hsl(var(--ch-primary))] pb-1 text-[hsl(var(--ch-primary))]">
              Index
            </span>
            <Link className="block text-sm text-[hsl(var(--ch-muted))] hover:text-[hsl(var(--ch-primary))]" href="/">
              Latest Reports
            </Link>
            <Link
              className="block text-sm text-[hsl(var(--ch-muted))] hover:text-[hsl(var(--ch-primary))]"
              href="/cities"
            >
              City Silos
            </Link>
          </div>
          <div className="space-y-3">
            <span className="ch-label-caps block border-b border-[hsl(var(--ch-primary))] pb-1 text-[hsl(var(--ch-primary))]">
              About
            </span>
            <Link
              className="block text-sm text-[hsl(var(--ch-muted))] hover:text-[hsl(var(--ch-primary))]"
              href="/dispatch"
            >
              Editorial Standards
            </Link>
            <Link className="block text-sm text-[hsl(var(--ch-muted))] hover:text-[hsl(var(--ch-primary))]" href="/dispatch">
              Dispatch Terminal
            </Link>
          </div>
        </nav>
      </div>
    </footer>
  )
}
